import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {HeaderService} from '../../../services/header-service';
import {NotificationStyleService} from '../../../services/notification-style-service';
import {IconComponent} from '../../elements/icon/icon.component';
import {Icons} from '../../../model/icon';
import {LoginService} from '../../../services/login.service';
import {TokenStorageService} from '../../../services/token.storage.service';
import {Router} from '@angular/router';
import {ScrollService} from '../../../services/scroll-service';
import {UserRole} from '../../../model/role.enum';
import {scrollUp} from '../../../functions/scroll-up';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    IconComponent
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
  loginGroup: FormGroup;
  error: string = '';

  constructor(
    private fb: FormBuilder,
    protected interfaceService: HeaderService,
    protected notificationStyle: NotificationStyleService,
    protected loginService: LoginService,
    protected tokenStorageService: TokenStorageService,
    private router: Router,
    public scrollService: ScrollService
  ) {
    this.loginGroup = this.fb.group({
      username: [''],
      password: [''],
    });
  }

  ngOnInit() {
    this.scrollService.lockScroll();
    this.interfaceService.setActiveInterface('header-container-white');
    this.notificationStyle.setActiveStyle(1);
  }

  ngOnDestroy() {
    this.scrollService.unlockScroll();
  }

  login() {
    this.loginService.login(this.loginGroup.get('username')?.value, this.loginGroup.get('password')?.value).subscribe({
      next: (loginInfo) => {
        this.tokenStorageService.saveLoginInfo(loginInfo);
        this.loginService.update();
        this.redirectBasedOnRole();
      },
      error: (error) => {
        this.error = error.status + " " + error.message;
      }
    });
  }

  private redirectBasedOnRole(): void {
    const currentUrl = this.router.parseUrl(this.router.url);
    const returnUrl = currentUrl.queryParams['returnUrl'];
    if (returnUrl && returnUrl !== '' && returnUrl !== '/') {
      scrollUp();
      this.router.navigateByUrl(returnUrl).then();
      return;
    }
    if (this.tokenStorageService.hasRole(UserRole.ADMIN)) {
      scrollUp();
      this.router.navigate(['/admin']).then();
    } else if (this.tokenStorageService.hasRole(UserRole.VOUCHER_MANAGER)) {
      scrollUp();
      this.router.navigate(['/documents']).then();
      // this.router.navigate(['/admin']).then();
    } else {
      scrollUp();
      this.router.navigate(['/']).then();
    }
  }

  protected readonly Icons = Icons;
}
